<div id="wrapper">
    <app-menu [tabActive]="this.tabActive"></app-menu>
    <app-loading-screen></app-loading-screen>
    <div class="allcont">
      <div class="basicrow">
        <div class="basicrow graybg">
          <div class="container">
            <div *ngIf="this.companyName!=null&&this.companyName!=''&&this.companyName!=undefined" class="fulltitle f-btitle" >
              <i class="fa fa-briefcase" aria-hidden="true"></i> {{this.companyName}}
            </div>
            <div class="basicrow m-top">
              <div class="basicrow">
                 <app-payments-invoices></app-payments-invoices>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="basicrow h-mbott">
        <div class="container">
          <div class="basicrow m-top-i">
            <div class="acc-susc">
              <app-accounts-subscribers></app-accounts-subscribers>
            </div>
            <div class="new-boxes">
                <app-support></app-support>
            </div>
          </div>
        </div>
      </div>
      <div class="basicrow m-top-i">
        <div class="basicrow graybg">
          <div class="container">
            <div class="basicrow">
                <app-carousel-news></app-carousel-news>
            </div>
          </div>
        </div>
        <div class="customer-service-text">
          <div class="title-service">
            Servicio al Cliente
          </div>
          <div class="subtitle-service">
            Ayuda y soporte
          </div>
          <div class="description-service">
            <span>
              Para disputas de facturas, por favor envíenos sus reclamación a <a href="mailto:claimswholesale@claropr.com">claimswholesale@claropr.com</a>, utilizando el formato incluido en el link
            </span>
          </div>
        </div>
      </div>
    </div>
    <app-footer></app-footer>
</div>